'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Divider = require('@narvar/nth-bit-divider');
var styles = require('./styles.js');
var index = require('../../components/Language/index.js');
require('../../components/Spinner/index.js');
require('../../components/Button/styles.js');
require('@babel/runtime/helpers/extends');
require('../../components/LocationCard/index.js');
require('../../components/PudoCard/index.js');
require('../../components/ItemCard/index.js');
require('../../components/SelectItem/index.js');
require('../../components/SelectList/index.js');
require('../../components/ErrorBanner/index.js');
require('../../components/Footer/index.js');
require('../../components/StickyFooter/index.js');
require('../../components/SwatchesList/index.js');
require('@narvar/nth-bit-text-link');
require('../../components/Backdrop/index.js');
require('../../components/LineItemsGroup/index.js');
require('../../components/Skeleton/ItemCardSkeleton.js');
require('../../components/Skeleton/LineItemSkeleton.js');
require('../../components/Skeleton/PudoCardSkeleton.js');
var Currency = require('../../transformers/Currency.js');
var string = require('../../transformers/string.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);

const Total = props => {
  var _items$, _items$$price, _fees$, _fees$$amount, _props$refund, _props$refund2, _props$refund2$refund, _props$refund3, _props$refund3$refund, _props$refund4, _props$refund4$refund;
  const {
    items,
    fees,
    refund,
    locale,
    includeCurrency
  } = props;
  const subtotal = (refund === null || refund === void 0 ? void 0 : refund.subtotal) ??
  // fallback to sum all returning line item values
  (items ?? []).reduce((ret, item) => {
    var _item$price, _item$exchangeTo, _item$exchangeTo$pric;
    const itemPrice = ((_item$price = item.price) === null || _item$price === void 0 ? void 0 : _item$price.value) ?? 0;
    const exchangePrice = ((_item$exchangeTo = item.exchangeTo) === null || _item$exchangeTo === void 0 ? void 0 : (_item$exchangeTo$pric = _item$exchangeTo.price) === null || _item$exchangeTo$pric === void 0 ? void 0 : _item$exchangeTo$pric.value) ?? 0;
    ret.value += (itemPrice - exchangePrice) * item.quantity;
    return ret;
  }, {
    value: 0,
    currency: (items === null || items === void 0 ? void 0 : (_items$ = items[0]) === null || _items$ === void 0 ? void 0 : (_items$$price = _items$.price) === null || _items$$price === void 0 ? void 0 : _items$$price.currency) ?? 'USD'
  });
  const defaultLabelFee = {
    type: 'LABEL_FEE',
    amount: {
      value: 0,
      currency: (fees === null || fees === void 0 ? void 0 : (_fees$ = fees[0]) === null || _fees$ === void 0 ? void 0 : (_fees$$amount = _fees$.amount) === null || _fees$$amount === void 0 ? void 0 : _fees$$amount.currency) ?? 'USD'
    }
  };
  const labelFee = (fees === null || fees === void 0 ? void 0 : fees.find(f => f.type === 'LABEL_FEE')) ?? defaultLabelFee;
  const displayFees = refund !== null && refund !== void 0 && refund.displayAllFees && fees && fees.length > 0 ? fees : [labelFee];
  const total = (refund === null || refund === void 0 ? void 0 : refund.total) ??
  // fallback to subtotal - fees
  displayFees.reduce((ret, fee) => ({
    ...ret,
    value: ret.value - fee.amount.value
  }), subtotal);
  return /*#__PURE__*/React__default["default"].createElement(styles.StyledUnorderedList, null, /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement(styles.StyledItemWrapper, null, /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReviewTotalsSubtotal"
  })), /*#__PURE__*/React__default["default"].createElement(Currency.Currency, {
    locale: locale,
    includeCurrency: includeCurrency,
    currency: subtotal.currency,
    value: subtotal.value
  })), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null)), displayFees.map((fee, i) => /*#__PURE__*/React__default["default"].createElement("li", {
    key: i
  }, /*#__PURE__*/React__default["default"].createElement(styles.StyledItemWrapper, null, /*#__PURE__*/React__default["default"].createElement("span", null, fee.title ?? /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReviewTotalsShippingFee"
  })), fee.displayAmount ?? /*#__PURE__*/React__default["default"].createElement(Currency.Currency, {
    locale: locale,
    includeCurrency: includeCurrency,
    currency: fee.amount.currency,
    value: fee.amount.value
  })), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null))), /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement(styles.StyledItemWrapper, null, /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement("strong", null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: total.value < 0 ? 'returnsReviewTotalsEstimatedCharge' : 'returnsReviewTotalsEstimatedRefund'
  }))), /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement("strong", null, /*#__PURE__*/React__default["default"].createElement(Currency.Currency, {
    locale: locale,
    includeCurrency: includeCurrency,
    currency: total.currency,
    value: total.value < 0 ? total.value * -1 : total.value
  })))), ((_props$refund = props.refund) === null || _props$refund === void 0 ? void 0 : _props$refund.refundMethod) && /*#__PURE__*/React__default["default"].createElement(styles.StyledItemWrapper, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: `returnsReviewRefundTo_${string.camelCase((_props$refund2 = props.refund) === null || _props$refund2 === void 0 ? void 0 : (_props$refund2$refund = _props$refund2.refundMethod) === null || _props$refund2$refund === void 0 ? void 0 : _props$refund2$refund.type)}`,
    replacementTokens: [{
      token: '{{name}}',
      value: ((_props$refund3 = props.refund) === null || _props$refund3 === void 0 ? void 0 : (_props$refund3$refund = _props$refund3.refundMethod) === null || _props$refund3$refund === void 0 ? void 0 : _props$refund3$refund.name) ?? ''
    }, {
      token: '{{description}}',
      value: ((_props$refund4 = props.refund) === null || _props$refund4 === void 0 ? void 0 : (_props$refund4$refund = _props$refund4.refundMethod) === null || _props$refund4$refund === void 0 ? void 0 : _props$refund4$refund.description) ?? ''
    }]
  })), /*#__PURE__*/React__default["default"].createElement(styles.StyledDisclaimerText, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReviewTotalsHelpText"
  }))));
};

exports.Total = Total;
